import { AllocationField } from "./allocationField";
import { FilterField } from "./filterField";
import { InputFieldReference } from "./inputFieldReference";
import { MetadataField } from "./metadataField";

export class FieldDefinition{
    public index!:number;
    public name!:string;
    public dataType!:string;
    public dataPattern?:string;
    public fieldLength?:number;
    public paddingDirection?:string;
    public paddingCharacter?:string;
    public mandatory:boolean = false;
    public isOutputParameter:boolean = false;

    get displayInfo(){
        return this.name + ' | ' + this.dataType + (this.dataPattern?(' | ' + this.dataPattern):'');
    }

    public matchesMetadataField(mdf:MetadataField){
        return (this.index==mdf.index); //no more comparison by name
    }

    public matchesFilterField(ff:FilterField){
        return (this.index==ff.index); //no more comparison by name
    }

    get metaDataField(){
        let mdf = new MetadataField();
        mdf.name=this.name;
        mdf.index=this.index;
        return mdf;
    }

    get filterField(){
        let ff = new FilterField();
        ff.name=this.name;
        ff.index=this.index;
        return ff;
    }

    get inputFieldReference(){
        let ifr = new InputFieldReference();
        ifr.name=this.name;
        ifr.index=this.index;
        return ifr;
    }

    get allocationField(){
        let af = new AllocationField();
        af.name=this.name;
        af.index=this.index;
        return af;
    }

    public updateFieldDefinition(sourceFd:FieldDefinition){
        this.name=sourceFd.name;;
        this.dataType=sourceFd.dataType;
        this.dataPattern=sourceFd.dataPattern;
        this.fieldLength=sourceFd.fieldLength;
        this.paddingDirection=sourceFd.paddingDirection;
        this.paddingCharacter=sourceFd.paddingCharacter;
        this.mandatory=sourceFd.mandatory;
        this.isOutputParameter=sourceFd.isOutputParameter;
    }
}